import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { Pop } from './Pop';

// Lo stato vuoto di una pagina: nella veste pop (tela «PopTown Pop Style») un pop grande al posto
// dell'icona, dentro una card. Senza `pop` resta l'icona.
export function EmptyState({
  icon,
  title,
  hint,
  action,
  pop,
}: {
  icon: string;
  title: string;
  hint: string;
  action?: ReactNode;
  /** l'avatar del pop che accoglie (es. `developer-01`) */
  pop?: string;
}) {
  return (
    <div
      className={pop ? 'empty-pop' : undefined}
      style={pop ? undefined : { textAlign: 'center', padding: '48px 20px' }}
    >
      {pop ? (
        <Pop avatar={pop} size={140} />
      ) : (
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            background: 'var(--bg-2)',
            display: 'grid',
            placeItems: 'center',
            margin: '0 auto 12px',
          }}
        >
          <Icon name={icon} size={24} color="var(--faint)" />
        </div>
      )}
      <div className={pop ? 't-h2' : 't-h3'} style={{ marginBottom: 4 }}>
        {title}
      </div>
      <div
        className="t-small dim"
        style={{ marginBottom: action ? 14 : 0, maxWidth: 440, marginInline: 'auto' }}
      >
        {hint}
      </div>
      {action}
    </div>
  );
}
